import { CancelButton } from '../styles';
import {
  DialogActions,
  DialogContent,
  DialogSubtitle,
  DialogTitle,
  RemoveButton,
  StyledDialog,
} from './styles';

interface RemoveDocumentDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  subtitle: string;
  confirmLabel: string;
}

export function RemoveDocumentDialog({
  open,
  onClose,
  onConfirm,
  title,
  subtitle,
  confirmLabel,
}: RemoveDocumentDialogProps): JSX.Element {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogSubtitle>{subtitle}</DialogSubtitle>
        <DialogActions>
          <CancelButton onClick={onClose} sx={{ width: 220 }}>
            Cancelar
          </CancelButton>
          <RemoveButton onClick={onConfirm}>{confirmLabel}</RemoveButton>
        </DialogActions>
      </DialogContent>
    </StyledDialog>
  );
}
